import { Box, Typography, Spacer, Button } from '@bcp-nextgen-dx-component-factory/design-system';
import { rem } from '@helpers';
import { RoundCallSuccess } from '@icons';

import { useRequestToCallSuccessHelper } from './requestToCallSuccess.helper';

export interface RequestToCallSuccessProps {
	nameToContact: string;
}

export const RequestToCallSuccess: React.FC<RequestToCallSuccessProps> = (props) => {
	const { resources, back } = useRequestToCallSuccessHelper(props);

	return (
		<Box
			styles={{
				flexDirection: 'column',
				minHeight: '100%',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<RoundCallSuccess />
			<Box styles={{ margin: rem(24, 0, 48, 0), flexDirection: 'column', alignItems: 'center' }}>
				<Typography appearance="headline-200-02">{resources.title}</Typography>
				<Spacer vertical={8} />
				<Typography colorToken="primary-light" appearance="body-100-02">
					{resources.subTitle}
				</Typography>
			</Box>
			<Button onPress={back}>{resources.buttonTitle}</Button>
		</Box>
	);
};
